module.exports = __webpack_public_path__ + "static/media/25.34143d4d.jpg";